var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBelgium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3737 1.59869C15.0737 1.11634 13.6676 0.852295 12.1998 0.852295C10.732 0.852295 9.32589 1.11634 8.02591 1.59869L6.98242 12.8523L8.02591 24.1059C9.32589 24.5883 10.732 24.8523 12.1998 24.8523C13.6676 24.8523 15.0737 24.5883 16.3737 24.1059L17.4172 12.8523L16.3737 1.59869Z",
    fill: "#FFDA44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2001 12.8522C24.2001 7.69266 20.9436 3.2941 16.374 1.59863V24.1059C20.9436 22.4103 24.2001 18.0118 24.2001 12.8522Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.200195 12.8522C0.200195 18.0118 3.4567 22.4103 8.0263 24.1059V1.59863C3.4567 3.2941 0.200195 7.69266 0.200195 12.8522Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelgium);
export default __webpack_public_path__ + "static/media/Belgium.151442dd13af80594b95c8b0fd8fc55f.svg";
export { ForwardRef as ReactComponent };